import React from 'react';
import { usePhoneInputI18n } from '../../lib/phoneInputI18n';
import { useCheckoutLocalization } from '../../hooks/useCheckoutLocalization';
import { useLazyComponent } from '../../hooks/useLazyComponent';
import { TextInput } from '../Form';

type Props = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  country?: string;
  required?: boolean;
  placeholder?: string;
  error?: string;
  rowPosition?: 'first' | 'last';
};

export function AddressPhoneInput({
  id,
  value,
  onChange,
  country,
  required,
  placeholder = 'Phone',
  error,
  rowPosition,
}: Props) {
  const { locale } = useCheckoutLocalization();
  const { i18n, ready } = usePhoneInputI18n(locale);
  const AddressPhoneIntl = useLazyComponent(() => import('./AddressPhoneIntl'));

  return (
    <div className="cp-address-row cp-address-phone-row" data-row-position={rowPosition}>
      {AddressPhoneIntl && ready ? (
        <AddressPhoneIntl
          id={id}
          value={value ?? ''}
          onChange={onChange}
          country={country}
          required={required}
          placeholder={placeholder}
          i18n={i18n}
        />
      ) : (
        <TextInput
          id={id}
          name={id}
          type="tel"
          placeholder={placeholder}
          required={required}
          value={value ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          className="cp_form-telinput w-full !border-0 !rounded-none"
        />
      )}
      {error && (
        <div role="alert" className="text-sm text-red-600 px-3 pb-2">
          {error}
        </div>
      )}
    </div>
  );
}
